export default __webpack_public_path__ + "static/media/rest.1818d57e.png";